// Centralized configuration for environment-based settings
// CRA requires env vars prefixed with REACT_APP_
const envApiBase = process.env.REACT_APP_API_BASE;
if (!envApiBase) {
  // eslint-disable-next-line no-console
  console.warn('REACT_APP_API_BASE is not set. API requests will target relative paths.');
}
export const API_BASE = envApiBase || 'https://api.barbotine.xyz';


